var EmailSend = require('./x-timeline-entry-email-sent')

module.exports = EmailSend
